module.exports = __webpack_public_path__ + "img/Aufheller_radialRamp.46730697.png";